












































































import Table from '@/components/Table/Index.vue';
import SecretPasswordData from '@/data/SecretPasswordData';
import ResetSubpassLogData from '@/data/ResetSubPassLogData';
import SecretPasswordBody from '@/components/Table/SecretPasswordBody.vue';
import ResetSubPassLogBody from '@/components/Table/ResetSubPassLogBody.vue';
import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import SecretPasswordModule from '@/store/modules/SecretPassword';
import { IUsername, IUserList, IResetSubPassLog } from '@/interface/SecretPassword';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import GeneralModule from '@/store/modules/General';
import moment from 'moment';

@Component({
  components: {
    SecretPasswordBody,
    ResetSubPassLogBody,
    Table,
  },
})
export default class Maintenance extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  TableHeadSecretPassword = SecretPasswordData.TableHeadSecretPassword;

  TableHeadResetSubPassLog = ResetSubpassLogData.TableHeadResetSubPassLog;

  SecretPasswordInstance = getModule(SecretPasswordModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  historyPage = 1;

  userData: IUserList = {
    username: '',
    role: '',
    source: '',
  };

  searchUsername: IUsername = {
    username: '',
  };

  resetSubPassLogData: IResetSubPassLog[] = [
    {
      operator: {
        id: '',
        username: '',
      },
      user: {
        id: '',
        username: '',
      },
      timestamp: '',
    },
  ]

  historyData: IResetSubPassLog[] = [
    {
      operator: {
        id: '',
        username: '',
      },
      user: {
        id: '',
        username: '',
      },
      timestamp: '',
    },
  ]

  isShowLogModal = false

  async findUser(username: string) {
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.SecretPasswordInstance.FindUser(username);
    this.userData = data;
    if (status.code) this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
  }

  async resetSecretPassword(currentUsername: string) {
    const selectedUsername: IUsername = {
      username: currentUsername,
    };
    const { status } = await this.SecretPasswordInstance.ResetSubPassword(selectedUsername);
    this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
  }

  async fecthResetSubPassLog(currentUsername: string) {
    this.historyPage = 1;
    const selectedUsername: IUsername = {
      username: currentUsername,
    };
    const { data, status } = await this.SecretPasswordInstance
      .FecthResetSubPassLog(selectedUsername);
    const resData = data.map((item: IResetSubPassLog) => ({
      ...item,
      timestamp: moment(item.timestamp).add(-1, 'h').format('DD/MM/YYYY, hh:mm:ss a'),
    }));
    this.historyData = resData;
    this.pageRenderHistory();
    this.isShowLogModal = true;
    this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
  }

  pageRenderHistory() {
    this.resetSubPassLogData = this.historyData
      .slice((this.historyPage - 1) * 5, (this.historyPage * 5));
  }

  handlePage(param) {
    this.historyPage += param;
    this.pageRenderHistory();
  }
}
